<template>
  <div v-if="isHelpModalOpen" class="helpModal">
    <div class="helpModal-background" @click="closeHelpModal"></div>
    <div class="helpModal-content">
      <h5 class="title is-5">非検出エリアの設定方法</h5>
      <br />
      <h5 class="title is-5">1. 新しいエリアの追加</h5>
      <p>・ 「+エリアを追加」をクリックすると、新しいエリアを追加できます。</p>
      <p>・ クリックすることでエリアの頂点を追加できます</p>
      <p>・ 最初に選択した頂点を再度クリックすることで、追加が完了します。</p>
      <br />
      <h5 class="title is-5">2. エリアの削除</h5>
      <p>
        ・ 「非検出エリアメニュー」メニューから削除したいエリアを選択します。
      </p>
      <p>・ 「削除」をクリックすることで、選択したエリアを削除できます。</p>
      <br />
      <h5 class="title is-5">3. 非検出エリアの登録</h5>
      <p>
        ・ 「確定」ボタンをクリックすることで、非検出エリアの設定が完了します。
      </p>
      <br />
      <button @click="closeHelpModal" class="button is-danger ml-3">
        閉じる
      </button>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "UndetectedAreaJa",
  props: {
    isHelpModalOpen: Boolean,
  },
  emits: ["close"],
  setup(props, { emit }) {
    const closeHelpModal = () => {
      emit("close");
    };
    return { closeHelpModal };
  },
});
</script>

<style>
.helpModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.helpModal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}

.helpModal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>
